angular.module('rjmNg.directives').directive 'pdwDataTargetsList', [
  "notification"
  "errorConstants"
  "app"
  "WarehouseConnections"
  "$location"
  "CONNECTION_CHECKS"
  "$clientAppUrl"
  "$timeout"
  "appRoute"
  (
    notification
    errorConstants
    app
    WarehouseConnections
    $location
    CONNECTION_CHECKS
    $clientAppUrl
    $timeout
    appRoute
  ) ->

    restrict: 'E'
    scope: {
      isUpdating: "="
    }
    templateUrl: 'directive.pdwDataTargetsList.html'
    link: (scope, elem, attrs, rjmUi) ->

      pollingAttemptsCount = 0
      maxPollingIntervalSecs = 32
      WarehouseConnectionsInstance = WarehouseConnections(app.getClientId())
      scope.supportEmail = app.getSupportEmail()
      scope.confirm = {}
      scope.dataTargetToDelete = {}
      scope.dataTargets = []
      scope.maxDataTargets = 1
      scope.user = app.getUser()
      scope.showDataTarget = (scope.user.supportAdminId\
        and app.hasFeatureFlag("PDW_SUPPORT_CLIENT"))\
        or app.hasFeatureFlag("PDW_CLIENT")
      scope.CONNECTION_CHECKS = CONNECTION_CHECKS
      scope.isUpdating = false

      scope.addDataTarget = ->
        $location.path appRoute("/settings/datatarget")

      scope.selectDataTargetToDelete = (dataTarget) ->
        scope.dataTargetToDelete = dataTarget
        scope.showDeleteModal()

      scope.prettyStatus = (status) ->
        switch status
          when CONNECTION_CHECKS.STATUS.PENDING then "Testing..."
          when CONNECTION_CHECKS.STATUS.OK then "OK"
          when CONNECTION_CHECKS.STATUS.FAILED then "FAIL"

      scope.prettyReason = (reason) ->
        return 'success' if reason is ''

        return CONNECTION_CHECKS.FAIL_REASON[reason].replace('_', ' ').toLowerCase()

      scope.getReasonMessage = (reason) ->
        return 'Successfully connected to your Redshift instance.' if reason is ''

        return CONNECTION_CHECKS.FAIL_REASON_MESSAGES[reason]

      scope.confirmDelete = ->
        scope.isUpdating = true
        scope.hideDeleteModal()
        WarehouseConnectionsInstance.delete scope.dataTargetToDelete
        .then deleteOnSuccess, deleteOnError

      scope.cancelDelete = ->
        delete scope.dataTargetToDelete
        scope.hideDeleteModal()

      scope.showDeleteModal = ->
        $('#deleteDataTargetModal').modal()
        return

      scope.hideDeleteModal = ->
        $('#deleteDataTargetModal').modal('hide')
        return

      fetchDataTargets = ->
        scope.isUpdating = true
        WarehouseConnectionsInstance.get().then getOnSuccess, getOnError

      fetchChecks = (dataTarget) ->
        $timeout ->
          WarehouseConnectionsInstance.checks(dataTarget)
          .then (checks) ->
            if isArray(checks) and checks.length > 0
              angular.extend dataTarget, checks: checks.reverse()
            else if dataTarget.check?
              angular.extend dataTarget, checks: [dataTarget.check]
            else
              getOnError()
              return
            if dataTarget.checks[0].status is CONNECTION_CHECKS.STATUS.PENDING
              pollingAttemptsCount += 1
              fetchChecks dataTarget
            else
              scope.isUpdating = false
          , ->
            angular.extend dataTarget, checks: [dataTarget.check]
            if dataTarget.check.status is CONNECTION_CHECKS.STATUS.PENDING
              pollingAttemptsCount += 1
              fetchChecks dataTarget
            else
              scope.isUpdating = false
        , getPollingIntervalMillisecs()

      isArray = (obj) ->
        Object.prototype.toString.call(obj) is '[object Array]'

      getPollingIntervalMillisecs = ->
        calculatedIntervalSecs = Math.pow(2, pollingAttemptsCount)
        Math.min(calculatedIntervalSecs, maxPollingIntervalSecs) * 1000

      getOnSuccess = (successResponse) ->
        if successResponse.length > 0
          scope.dataTargets = _(successResponse).map (dataTarget) ->
            angular.extend dataTarget,
              link: $clientAppUrl "/settings/datatarget/#{dataTarget.id}/"
              prettyConnectionType: "Redshift"
          for target in scope.dataTargets
            WarehouseConnectionsInstance.check target
            .then ->
              fetchChecks target
            , ->
              getOnError()
        else
          scope.dataTargets = []
          scope.isUpdating = false

      getOnError = (errorReesponse) ->
        notification.error("Server Error", errorConstants.SERVER_ERROR_MESSAGE, "dataTarget")
        scope.isUpdating = false

      deleteOnSuccess = (successResponse) ->
        notification.success("Delete Successful", "Successfully deleted your connection.", "global")
        fetchDataTargets()

      deleteOnError = (errorResponse) ->
        notification.error("Server Error", errorConstants.SERVER_ERROR_MESSAGE, "dataTarget")
        scope.isUpdating = false

      if scope.showDataTarget
        scope.notificationTemplate = 'template.notification.supportLink.html'
        fetchDataTargets()

]
